export class User {
  id: number;
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  phone: number;
  lastLogin: Date;
  birthday: Date;
  status: string;
  address: string;
  avatar: string;
  role: string;

  constructor(
    id,
    firstName,
    lastName,
    username,
    email,
    phone,
    lastLogin,
    birthday,
    status,
    address,
    avatar,
    role
  ) {
    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.username = username;
    this.email = email;
    this.phone = phone;
    this.lastLogin = lastLogin;
    this.birthday = birthday;
    this.status = status;
    this.address = address;
    this.avatar = avatar;
    this.role = role;
  }

  getID() {
    return this.id;
  }
  getFirstName() {
    return this.firstName;
  }

  getLastName() {
    return this.lastName;
  }

  getUsername() {
    return this.username;
  }

  getEmail() {
    return this.email;
  }

  getPhone() {
    return this.phone;
  }

  getLastLogin() {
    return this.lastLogin;
  }

  getBirthday() {
    return this.birthday;
  }

  getStatus() {
    return this.status;
  }

  toString() {
    return User.toString();
  }
}
